import React, { useState, useEffect } from 'react';
import '../App2.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../componenteExtra/SidebarStaff';
import CronometroModal from './CronometroModal';
import PauseModal from './PauseModal';
import { Toaster, toast } from 'react-hot-toast';
import SessionManager from '../componenteExtra/SessionManager';
import DiferenciaModal from '../componenteExtra/DiferenciaModal';

const MisActividades = () => {
    const [activities, setActivities] = useState([]);
    const [filteredActivities, setFilteredActivities] = useState([]);
    const [selectedActivity, setSelectedActivity] = useState(null);
    const [isCronometroModalOpen, setIsCronometroModalOpen] = useState(false);
    const [isPauseModalOpen, setIsPauseModalOpen] = useState(false);
    const [nombreGet, setNombreGet] = useState('');
    const [inactive, setInactive] = useState(false);
    const [razonSocialFilter, setRazonSocialFilter] = useState(''); // Filtro por razón social
    const [filialFilter, setFilialFilter] = useState(''); // Filtro por filial
    const [rubroFilter, setRubroFilter] = useState('');
    const [isDiferenciaModalOpen, setIsDiferenciaModalOpen] = useState(false);
    const navigate = useNavigate();

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        const savedNombreGet = localStorage.getItem('nombre_get');
        if (savedNombreGet) {
            setNombreGet(savedNombreGet);
        }

        if (savedNombreGet) {
            fetchActivities(savedNombreGet);
        }
    }, []);

    useEffect(() => {
        if (nombreGet) {
            localStorage.setItem('nombre_get', nombreGet);
        }
    }, [nombreGet]);

    useEffect(() => {
        let timer;
        const resetTimer = () => {
            clearTimeout(timer);
            setInactive(false);
            timer = setTimeout(() => {
                setInactive(true);
                toast('Has estado inactivo por un tiempo. Cerrando sesión...');
                setTimeout(() => {
                    localStorage.removeItem('nombre_get');
                    navigate('/');
                }, 5000);
            }, 7200000); // 7200000 ms = 2 horas
        };

        // Eventos que reiniciarán el temporizador
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);

        // Iniciar el temporizador la primera vez
        resetTimer();

        return () => {
            clearTimeout(timer);
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
        };
    }, [navigate]);

    const fetchActivities = async (nombre) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/my_assignments2/${nombre}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const sortedActivities = response.data.sort((a, b) => new Date(a.fecha_de_termino) - new Date(b.fecha_de_termino));
            setActivities(sortedActivities);
            setFilteredActivities(sortedActivities); // Set initial filtered activities
        } catch (error) {
            console.error('Error fetching data: ', error);
        }
    };

    const handleStart = async (activity) => {
        try {
            await axios.put(`${process.env.REACT_APP_BACKEND_URL}/update_activity_status/${activity.id}`, null, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setSelectedActivity(activity);
            setIsCronometroModalOpen(true);
        } catch (error) {
            console.error('Error updating activity status:', error);
        }
    };

    const handlePause = (activity) => {
        setSelectedActivity(activity);
        setIsPauseModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsCronometroModalOpen(false);
        setIsPauseModalOpen(false);
        setSelectedActivity(null);
    };

    const handleSend = (activity) => {
        setSelectedActivity(activity);
        setIsDiferenciaModalOpen(true);
    };

    const confirmSend = async (diferencia, comentarioDiferencia) => {
        if (!diferencia) {
            toast.error("Debes seleccionar si hubo diferencias.");
            return;
        }

        const currentDate = new Date().toISOString().split("T")[0];
        const toastId = toast.loading("Enviando actividad...");

        try {
            let updatedEstadoStaff = selectedActivity.estados_staff + 1;
            if (selectedActivity.ultimo_revisado > selectedActivity.estados_staff) {
                updatedEstadoStaff = selectedActivity.ultimo_revisado;
            }

            await axios.post(`${process.env.REACT_APP_BACKEND_URL}/send_activity`, {
                id: selectedActivity.id,
                estados_staff: updatedEstadoStaff,
                fecha_estado_staff: currentDate,
                diferencia,
                comentario_diferencia: diferencia === "Sí" ? comentarioDiferencia : "",
            }, {
                headers: { Authorization: `Bearer ${token}` },
            });

            toast.dismiss(toastId);
            toast.success("Actividad enviada correctamente");
            setIsDiferenciaModalOpen(false);
            setTimeout(() => {
                navigate("/MisAsignaciones");
                fetchActivities(nombreGet); // Actualizar actividades sin recargar la página
            }, 1500);
        } catch (error) {
            console.error("Error sending activity:", error);
            toast.dismiss(toastId);
            toast.error("Error al enviar actividad");
        }
    };

    const isBetweenDates = (start) => {
        const today = new Date();
        return today >= new Date(start);
    };

    // Filtros
    useEffect(() => {
        let filtered = activities;

        if (razonSocialFilter) {
            filtered = filtered.filter(activity => activity.razon_social.toLowerCase().includes(razonSocialFilter.toLowerCase()));
        }

        if (filialFilter) {
            filtered = filtered.filter(activity => activity.filial.toLowerCase().includes(filialFilter.toLowerCase()));
        }

        if (rubroFilter) {
            filtered = filtered.filter(activity => activity.rubro_get.toLowerCase().includes(rubroFilter.toLowerCase()));
        }

        setFilteredActivities(filtered);
    }, [razonSocialFilter, filialFilter, rubroFilter, activities]);

    const totalActividades = filteredActivities.length;

    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Mis asignaciones - {nombreGet}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>

                    <div className="filter-section">
                        <label htmlFor="razonSocialFilter">Filtros - Razón social: </label>
                        <input
                            type="text"
                            id="razonSocialFilter"
                            value={razonSocialFilter}
                            onChange={(e) => setRazonSocialFilter(e.target.value)}
                        />

                        <label htmlFor="filialFilter">Filial: </label>
                        <input
                            type="text"
                            id="filialFilter"
                            value={filialFilter}
                            onChange={(e) => setFilialFilter(e.target.value)}
                        />
                        <label>Rubro GET: </label>
                        <input type="text" value={rubroFilter} onChange={(e) => setRubroFilter(e.target.value)} />
                    </div>

                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Código de Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Solicitante</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Encargado de auditoría</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Jefe de Grupo</th>
                                    <th>Subrogante</th>
                                    <th>Fecha Asignacion</th>
                                    <th>Fecha Inicio</th>
                                    <th>Fecha Termino</th>
                                    <th>Fecha Corte Auditoria</th>
                                    <th>Fecha de emisión final</th>
                                    <th>Horas GET</th>
                                    <th>Horas Estándar</th>
                                    <th>Comentario(s) Rechazos</th>
                                    <th>Comentario Pausa</th>
                                    <th>Documentación</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredActivities.map((activity, index) => {
                                    const isActive = isBetweenDates(activity.fecha_de_inicio,
                                        new Date(new Date(activity.fecha_de_termino)
                                            .setDate(new Date(activity.fecha_de_termino).getDate() + 5)));
                                    return (
                                        <tr key={index}>
                                            <td>{activity.codigo_proyecto}</td>
                                            <td>{activity.razon_social}</td>
                                            <td>{activity.filial}</td>
                                            <td>{activity.nombre_solicitante}</td>
                                            <td>{activity.tipo_solicitud}</td>
                                            <td>{activity.tipo_regulacion}</td>
                                            <td>{activity.encargado_auditoria}</td>
                                            <td>{activity.rubro_get}</td>
                                            <td>{activity.nombre_actividad_get}</td>
                                            <td>{activity.jefe_grupo}</td>
                                            <td>{activity.subrogante}</td>
                                            <td>{activity.fecha_asignada_actividad ? new Date(new Date(activity.fecha_asignada_actividad).toLocaleString('en-US', { timeZone: 'UTC' })).toLocaleDateString('es-ES') : ""}</td>
                                            <td>{activity.fecha_de_inicio ? new Date(new Date(activity.fecha_de_inicio).toLocaleString('en-US', { timeZone: 'UTC' })).toLocaleDateString('es-ES') : ""}</td>
                                            <td>{activity.fecha_de_termino ? new Date(activity.fecha_de_termino).toLocaleDateString("es-ES") : ""}</td>
                                            <td>{activity.fecha_corte_auditoria ? new Date(activity.fecha_corte_auditoria).toLocaleDateString("es-ES") : ""}</td>
                                            <td>{activity.fecha_emision ? new Date(new Date(activity.fecha_emision).toLocaleString('en-US', { timeZone: 'UTC' })).toLocaleDateString('es-ES') : ""}</td>
                                            <td>{activity.horas_get}</td>
                                            <td>{activity.horas_estandar}</td>
                                            <td>
                                                {activity.comentario_lider && <>-Lider: {activity.comentario_lider}<br /></>}
                                                {activity.comentario_seniorGET && <>-Senior GET: {activity.comentario_seniorGET}<br /></>}
                                                {activity.comentario_solicitante && <>-Solcitante: {activity.comentario_solicitante}</>}
                                            </td>
                                            <td>{activity.comentario_aclaracion}</td>
                                            <td>
                                                {activity.enlace_comentario ? (
                                                    <a href={activity.enlace_comentario} target="_blank" rel="noopener noreferrer" style={{ color: "#0066cc", textDecoration: "underline" }}>
                                                        Documentación
                                                    </a>
                                                ) : "-"}
                                            </td>
                                            <td>
                                                <button
                                                    className="action-button start-button"
                                                    onClick={() => handleStart(activity)}
                                                    disabled={!isActive}
                                                >
                                                    Iniciar
                                                </button>
                                                <button
                                                    className="action-button pause-button"
                                                    onClick={() => handlePause(activity)}
                                                >
                                                    Pausar
                                                </button>
                                                {activity.horas_estandar && (
                                                    <button
                                                        className="action-button send-button"
                                                        onClick={() => handleSend(activity)}
                                                    >
                                                        Enviar
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {selectedActivity && (
                <CronometroModal
                    isOpen={isCronometroModalOpen}
                    onRequestClose={() => { }} // Deshabilitar el cierre al hacer clic en el overlay
                    shouldCloseOnOverlayClick={false} // No permitir cerrar el modal haciendo clic fuera
                    activity={selectedActivity}
                    onClose={handleCloseModal}
                />
            )}
            {selectedActivity && (
                <PauseModal
                    isOpen={isPauseModalOpen}
                    onRequestClose={handleCloseModal}
                    activity={selectedActivity}
                />
            )}
            <DiferenciaModal
                isOpen={isDiferenciaModalOpen}
                onRequestClose={() => setIsDiferenciaModalOpen(false)}
                onSubmit={confirmSend}
            />
            <Toaster />
        </div>
    );
};

export default MisActividades;